import React, { Component } from "react";
import { Col, Row } from "reactstrap";

class CustomerProfileMenu extends Component {
  render() {
    return (
      <div>
        <br />
        <br />
        <br />
        <p>
          <hr />
        </p>
        <br />
        <Row>
          <Col className="customer-dash-option common-box " lg={10} md={10}>
            <a href="/contract-trips">
              <span className="mdi mdi-truck contract-menu-icon"></span>
              <h4>All your Trips > </h4>
              <p>All your trips from current and old orders.</p>
            </a>
          </Col>
        </Row>
        <hr />
      </div>
    );
  }
}

export default CustomerProfileMenu;
